export default "__VITE_ASSET__wp8NnNPu__"